import styled from 'styled-components';

/**
 * @typedef {{isRtl: boolean; isMobile: boolean;}} LegalContainerProps
 * @type {import('styled-components').StyledComponent<"div", LegalContainerProps, LegalContainerProps, never>} LegalContainer
 */
export const LegalContainer = styled.div`
  margin-top: ${(props) => (props.isMobile ? '20px' : '18px')};
  text-align: ${(props) => {
    if (props.isMobile) return 'center';
    return props.isRtl ? 'right' : 'left';
  }};
`;

/**
 * @typedef {{linkColor: string; focusColor: string; visitedColor: string;}} LegalLinkProps
 * @type {import('styled-components').StyledComponent<"a", LegalLinkProps, LegalLinkProps, never>} LegalLink
 */
export const LegalLink = styled.a`
  color: ${({ linkColor }) => linkColor};
  text-decoration: none;
  cursor: pointer;
  font-family: inherit;
  font-size: inherit;
  line-height: inherit;

  &:hover {
    text-decoration: underline;
  }

  &:focus-visible {
    outline: 2px solid ${({ focusColor }) => focusColor};
    outline-offset: 2px;
    border-radius: 2px;
  }

  &:visited {
    color: ${({ visitedColor, linkColor }) => visitedColor || linkColor};
  }
`;
